import React from "react";
import {Link} from 'react-router-dom';
import VisaType from "../component/VisaType";

const Visa = () => {
    return (

        <main className="main">

            <div className="site-breadcrumb"  style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/breadcrumb/01.jpg)`}}>
                <div className="container">
                    <h2 className="breadcrumb-title">ভিসার ধরণ</h2>
                    <ul className="breadcrumb-menu">
                        <li><Link className="nav-link" to={'/'}>হোম</Link></li>
                        <li className="active">ভিসার-ধরণ</li>
                    </ul>
                </div>
            </div>


            <VisaType />

        </main>
    );
}

export default Visa;